/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useMergeState } from '../../../irmlib/src/hooks'
import { setBusy, clearBusy, closeGeneralDialog, openGeneralDialog } from '../../../irmlib/src/containers'
import { useTheme } from 'irmlib/styles'
// import MuiDataTable from '../../Controls/MuiDataTable'
// import { Box } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
// import { getUser } from '../../../redux/global'
import { DateTime } from '../../../irmlib/src/components/FormControls'
import { today, getMonth } from '../../../irmlib/src/common'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as routePaths from '../../../navigation/routePaths'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'
import { OrderModifyModal } from './ViewActivityOrderModify'
// import { MenuButton } from 'irmlib/components/Controls'
import { MoreVert } from 'irmlib/icons'
import { ContainedButton, OutlinedButton, MenuButton } from 'irmlib/components/Controls'
// import { closeGeneralDialog, openGeneralDialog } from 'irmlib/containers'
import { successToast } from '../../../common/functions'
import { MaterialReactTable } from 'material-react-table'
import { Box, Typography } from '@mui/material'
import ExportCsv from '../../Controls/ExportCsv'
import { Visibility } from '@material-ui/icons'
// import { useParams, useLocation } from 'react-router-dom'


const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
`

const JobLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`
const initialState = {
  selectedData: [],
  showModalToModifyOrder: false,
  orderModifyRequesId: false,
}

const ViewActivityData = (props) => {
  const [, setState, getState] = useMergeState(initialState)
  const location = useLocation()
  const { selectedDatas } = location.state || {}
  const value = props.FilterData
  const theme = useTheme()
  const { t } = useTranslation()
  // const history = useHistory()
  const [myJobdata, setData] = React.useState([])
  const [selectedImage, setSelectedImage] = React.useState(null)
  const [requestData, setRequestData] = useState(false)

  useEffect(async() => {
    setRequestData(false)
    getPageData()
  }, [value])
  useEffect(async() => {
    getPageData()
    const unsubscribe = await gdeTransactions.getGdeActivity('listener', value, selectedDatas, setRequestData)
    return () => unsubscribe()
  }, [value])

  useEffect(async() => {
    getPageData()
  }, [requestData])

  const dataRet = async (val) => {
    setBusy()
    let collection
    if (requestData) {
      collection = requestData
    } else {
      collection = await gdeTransactions.getGdeActivity('normal', val, selectedDatas, false)
    }

    const activityList = []
    collection?.forEach((doc) => {
      const docData = doc.data()
      let dateOfCreation = false
      if (docData.createdTS) {
        dateOfCreation = moment(docData.createdTS.seconds, 'X').format('YYYY-MM-DD')
      }

      if (dateOfCreation === 'Invalid date') {
        dateOfCreation = docData.createdTS.substring(0, 10)
      }

      let boxCount = docData.boxCount
      let error = false
      if (docData?.boxCount === undefined && docData?.apiResponse?.status?.error?.message !== '') {
        boxCount = docData?.apiResponse?.status?.error?.message
        error = true
      }

      activityList.push({
        activityId: doc.id,
        status: docData.status,
        customer: docData.accountLevel1.toUpperCase(),
        assetType: docData.assetType,
        lob: docData.lob,
        // customTemplateName: docData.customTemplateName,
        customRequestName: docData.customRequestName,
        dateCreated: dateOfCreation,
        orderNumber: docData.orderId,
        imgReference: docData.imgReference,
        totalBoxes: boxCount,
        district: docData.district,
        remarks: docData.remarks,
        statusCount: docData.statusCount,
        boxCount: docData.boxCount,
        error: error
        // imgReference: 'https://storage.cloud.google.com/smartcatalog-sb/smartCatalog/gf465/RF20005727718/RF2005727718-1.jpg'
      })
    })
    setData(activityList)
    clearBusy()
    return activityList
  }


  // const handleStatusFilterChange = () => {
  //   if (getState()?.selectedData.length !== 0) {
  //     history.push(`${routePaths.myJobs}`)
  //     setState({ selectedData: [] })  
  //   }
  // }

  const getPageData = async (page, pageSize) => {
    try {
      const data = await dataRet(value)
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching page data:', error)
      return []
    }
  }

  const handleClose = () => {
    setSelectedImage(null)
  }

  const modifyOrderId = async(e, requestId) => {
    setState({
      showModalToModifyOrder: true,
      orderModifyRequesId: requestId,
    })
  }

  const handleOrderModifyModal = async() => {
    setState({
      showModalToModifyOrder: false,
      orderModifyRequesId: false,
    })
  }
  const handleCancelButtonOnClick = async (e, requestId) => {
    try {   
      const collection = { status: 'cancelled', updateTS: (new Date()).toISOString() }
      await gdeTransactions.updateRequestData(requestId.rowActivityId, collection) 
      closeGeneralDialog()
      handleClose()
      successToast({
        message: `${requestId.rowActivityId} ${t('smartCatalog.requestCancelSuccess')}`,
        title: t('toast.success'),
        autoHideDuration: 3000,
        isBlocking: false
      })
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error updating request data:', error)
    }
  }
  const ButtonsForCancelDialogBox = (rowActivityId) =>
    <>
      <OutlinedButton id={'boxList_dialogBoxButton_no'} onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton id={'boxList_dialogBoxButton_yes'} onClick={(e) => handleCancelButtonOnClick(e, rowActivityId)}>{t('buttons.Ok')}</ContainedButton>
    </>
  const onSelect = (value, rowActivityId) => {
    if (value === 'pending') {
      openGeneralDialog({
        title: t('options.cancelRequestTitle'),
        message: `${t('options.cancelConfirmMessage')} ${rowActivityId}`,
        noTranslateTitle: true,
        buttons: <ButtonsForCancelDialogBox rowActivityId={rowActivityId}/>,
        closeX: true
      })
    }
  }
  const ImageContainer = () => {
    return (
      <Dialog open={!!selectedImage} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>
            <img src={selectedImage} 
              alt="Box Image" 
              style={{ maxWidth: '100%', maxHeight: '100%' }} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {`${t('dataEntry.close')}`}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
  
  const columns = [
    {
      accessorKey: 'activityId',
      header: t('tableColumns.requestId'),
      Cell: ({ cell }) => {
        const dataIndex = cell.row.index
        const rowdata = myJobdata[dataIndex]
        return (
          <JobLink
            id={`myJobs_jobLink_${rowdata.activityId}`}
            theme={theme}
            to={{
              pathname: `${routePaths.activityList}/${rowdata.activityId}`,
              state: {
                fromAdmin: false,
                rowData: rowdata
              }
            }}
          >
            {rowdata.activityId}
          </JobLink>
        )
      },
    },
    {
      accessorKey: 'customRequestName',
      header: t('tableColumns.customRequestName'),
      filterFn: 'includesString',
    },
    {
      accessorKey: 'status',
      header: t('tableColumns.status'),
    },
    {

      accessorKey: 'customer',
      header: 'Customer',
    },
    {
      accessorKey: 'assetType',
      header: 'Asset Type',
    },
    {
      accessorKey: 'lob',
      header: t('tableColumns.lob'),

    },
    {
      accessorKey: 'dateCreated',
      header: t('tableColumns.dateCreated'),
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue || filterValue.length === 0) {
          return true
        }

        const filterMonth = new Date(filterValue[0])
        const rowDate = new Date(row.getValue(columnId)) 

        // Check if the row's date matches the selected month
        return rowDate.getFullYear() === filterMonth.getFullYear() &&
          rowDate.getMonth() === filterMonth.getMonth()
      },
      Filter: ({ column }) => {
        const { getFilterValue, setFilterValue } = column

        return (
          <DateTime
            label={t('tableColumns.dateCreated')}
            type='month'
            minDate={getMonth('2020-01')}
            maxDate={getMonth(today())}
            value={getFilterValue() ? getFilterValue()[0] : null}
            onChange={(selectedMonth) => {
              setFilterValue(selectedMonth ? [selectedMonth] : undefined)
            }}
          />
        )
      },
    },
    {
      header: t('tableColumns.boxes'),
      accessorKey: 'totalBoxes',
      Cell: ({ row }) => {
        const rowdata = row.original
        const totBoxCount = rowdata?.totalBoxes
        const error = rowdata?.error

        let textColor = 'black'
        let allowOrderModification = false
        if (error) {
          textColor = 'red'
          allowOrderModification = true
        }

        return (
          <span
            style={{ color: textColor, cursor: allowOrderModification ? 'pointer' : 'default' }}
            onClick={(e) => allowOrderModification && modifyOrderId(e, rowdata?.activityId)}
          >
            {totBoxCount}
          </span>
        )
      },
    },
    {
      accessorKey: 'orderNumber',
      header: 'Order Number',
    },
    {
      header: t('tableColumns.remarks'),
      accessorKey: 'remarks',
    },
    {
      header: t('tableColumns.imgReference'),
      accessorKey: 'imgReference',
      Cell: ({ cell }) => {
        const value = cell.getValue()
        if (value) {
          return (
            <Visibility
            style={{ cursor: 'pointer', fontSize: 32 }}
              onClick={() => {
                setSelectedImage(value)
              }}/>
          )
        } else {
          return null
        }
      }
    },
    {
      header: t('tableColumns.action'),
      accessorKey: 'modify',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const rowData = row.original
        const pendingStatus = rowData?.status
        const rowActivityId = rowData?.activityId
  
        if (pendingStatus?.includes('pending')) {
          return (
            <MenuButton
              id="allJobs_ellipsis"
              buttonIcon={<MoreVert />}
              rowdata={rowData}
              items={menuItems}
              onSelect={(value) => onSelect(value, rowActivityId)}
            />
          )
        }
        return null 
      },
    },
  ]
  const options = {
    filterType: 'dropdown',
    enableSelectAll: false,
    enableRowSelection: false,
    enableSorting: true,
  }
  const menuItems = [
    { value: 'pending', id: 'cancel_request', label: t('tableColumns.cancelRequest'), style: { color: theme.palette.primary.main } },
  ]

  return (
    <>
      <TableContainer>
        <Box boxShadow={2} borderRadius={4}>
          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '22px' }}>
            <Typography variant="h6" gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
              {t('smartCatalog.viewActivityData')}
            </Typography></div>
          <MaterialReactTable
            columns={columns}
            options={options}
            muiTableHeadCellProps={{
              sx: {
                color: '#58595B',
                fontWeight: 'bold',
              },
            }}
            prop={props}
            data={myJobdata}
            enableRowSelection
            enableExport={true}
            enableGlobalFilter
            enableColumnFilter
            enableColumnSorting
            enableGrouping={true}
            enableColumnResizing={true}
            initialState={{
              sorting: [
                {
                  id: 'dateCreated',
                  desc: true,
                },
              ],
              columnVisibility: { imgReference: true, modify: true },
              density: 'compact'
            }}
            renderTopToolbarCustomActions={({ table }) => {
              const isDisabled = !table.getIsSomeRowsSelected()
              const isNoData = myJobdata?.length === 0
              const isNoPageData = myJobdata?.length > 4
              return (
                // 1087: written a common component ExportCsv for making things easy 
                <ExportCsv
                  columns={columns}
                  isDisabled={isDisabled}
                  isNoData={isNoData}
                  isNoPageData={isNoPageData}
                  table={table}
                />
              )
            }}
            tableFor={'smart_catalog_view_requests'}
          />
        </Box>
        <ImageContainer/>
      </TableContainer>
      {getState()?.showModalToModifyOrder 
        ? (<OrderModifyModal
            showModal={getState()?.showModalToModifyOrder}
            requestId={getState()?.orderModifyRequesId}
            handleShowModal={handleOrderModifyModal}
          />) 
        : null}
    </>
  )
}
ViewActivityData.propTypes = {
  FilterData: PropTypes.object,
  // DataSearch: PropTypes.string,
}

export default ViewActivityData